<app-main-content mode="1col">
  <div class="app-container process">
    <div class="form">
      <gsm-form-nachbringen
        [formDefinitionModels]="formDefinitionModels"
        [aktInfo]="aktInfo"
        [isLoading]="isLoading"
        [isUploading]="isUploading"
        [uploadBytesLoaded]="uploadBytesLoaded"
        [uploadBytesTotal]="uploadBytesTotal"
        [cockpitUrl]="o30CockpitUrl$ | async"
        (submitData)="onSubmit($event)"
        (backToUebersichtEvent)="onBackToUebersicht()"
        (customEvent)="onCustomEvent($event)"
        (cancelUpload)="onCancelUpload()"
        (formChange)="onFormChange($event)"
      ></gsm-form-nachbringen>
    </div>
  </div>
</app-main-content>
